/** @file Binary search: first index whose value is >= the probe in an ascending array. */
import { readNum } from './readNum';

/** First i with sorted[i] >= value (sorted.length when none); O(log n). */
export function sortedLowerBound(sorted: ArrayLike<number>, value: number): number {
  let lo = 0;
  let hi = sorted.length;
  while (lo < hi) {
    const mid = (lo + hi) >>> 1;
    if (readNum(sorted, mid) < value) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}
